var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lobby-(Final)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Lobby_Final_Desktop-(1920px)",
    transform: "translate(-388.000000, -403.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-65",
    transform: "translate(215.000000, 347.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Crown",
    transform: "translate(173.000000, 56.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 12,
    height: 12
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 0.252632)",
    fillRule: "nonzero",
    id: "Path"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FA8C00",
    points: "1.26315789 9.47368421 10.7368421 9.47368421 10.7368421 11.3684211 1.26315789 11.3684211"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FF8C00",
    points: "1.26315789 7.57894737 5.95754324 0 10.7368421 7.57894737"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#EDA500",
    points: "10.8858981 8.21052632 12 1.89473684 2.52631579 7.96067454"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FEC400",
    points: "1.06837866 8.21052632 0 1.89473684 8.84210526 8.21052632"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.feddadd2c9eed0bc97b8b420c66abc6b.svg";
export { ForwardRef as ReactComponent };